import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import mail from 'assets/images/Dashboard/mail-request.svg';
import call from 'assets/images/Dashboard/call-request.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import ReusablePagination from 'components/commom/Pagination';
import CommonToast from 'components/commom/CommonToast';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';
import SwitchList from 'components/commom/SwitchList';
import LabelWithInput from 'components/commom/LabelWithInput';
import AddIcon from 'assets/images/Dashboard/add-dashboard.svg';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Box, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SkinAnalyserImg from 'assets/images/Enterprise/Skin Analyser.png';
import SkinConcernImg from 'assets/images/Enterprise/Skin Concern Identifier.png';
import HairAnalyserImg from 'assets/images/Enterprise/Hair Analyser.png';
import CreateEnterprise from 'Pages/Admin/Enterprise/CreateEnterprise';
import { enterpriseDetail } from 'routes/AppUrls';
import { getEnterpriseCallAPI } from 'store/Enterprise/enterprise/getEnterprise/action';
import { ClearTokenRedirectLogin } from 'utils/general';
import { deleteEnterpriseCallAPI } from 'store/Enterprise/enterprise/deleteEnterprise/action';
import {
  basicDetailsValue,
  PARTICULAR_ENTERPRISE,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import { getDoctorDrop } from 'store/getDoctorListDropdown/getDoctorListDropdownAction';
import { getMasterData } from 'store/masterData/masterDataAction';
import RefreshIcon from '@mui/icons-material/Refresh';
import { resendEnterpriseInviteCallAPI } from 'store/Enterprise/enterprise/resendEnterpriseInvite/action';

const Enterprise = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState({
    search: '',
  });
  const [viewData, setViewData] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [countryData, setCountryData] = useState({});
  const [enterpriseTypeData, setEnterpriseTypeData] = useState({});
  const [productInventoryData, setProductInventoryData] = useState({});
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const itemsPerPage = 10;

  const enterpriseList = useSelector(
    (state) => state?.getEnterpriseReducer?.users?.data
  );
  const enterpriseLoader = useSelector(
    (state) => state?.getEnterpriseReducer?.loading
  );
  const enterpriseDeleteLoader = useSelector(
    (state) => state?.deleteEnterpriseReducer?.loading
  );

  useEffect(() => {
    getCountryData();
    setLoading(true);
  }, []);

  const getEnterpriseData = (page = 1, data = '') => {
    dispatch(
      getEnterpriseCallAPI(
        `${data ? `?search_text=${data}` : `?page=${page}`}`,
        {
          run: true,
          handleFunction: (res) => {
            setLoading(false);
            setCount(Math.ceil(res?.count / itemsPerPage));
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
          },
        }
      )
    );
  };

  const getCountryData = () => {
    dispatch(
      getDoctorDrop({
        run: true,
        handleFunction: (res) => {
          setCountryData(res?.data);
          getEnterpriseTypeData();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const getEnterpriseTypeData = () => {
    dispatch(
      getMasterData(
        {
          run: true,
          handleFunction: (res) => {
            setEnterpriseTypeData(res?.data?.[0]?.values);
            getProductInventaryData();
          },
          error: true,
          handleErrorFunction: (res) => {},
        },
        'enterprise-type'
      )
    );
  };

  const getProductInventaryData = () => {
    dispatch(
      getMasterData(
        {
          run: true,
          handleFunction: (res) => {
            setProductInventoryData(res?.data?.[0]?.values);
            getEnterpriseData(1, '');
          },
          error: true,
          handleErrorFunction: (res) => {},
        },
        'product-inventory'
      )
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    getEnterpriseData(value);
  };

  const handleAction = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    getEnterpriseData(1, '');
  };

  const handleApply = () => {
    getEnterpriseData(page, formData?.search);
  };

  const handleDelete = () => {
    dispatch(
      deleteEnterpriseCallAPI(viewData?.id, {
        run: true,
        handleFunction: () => {
          setIsModalActive(false);
          getEnterpriseData(page);
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const handleEnterpriseDetail = (data) => {
    dispatch(basicDetailsValue(PARTICULAR_ENTERPRISE, data));
    navigate(enterpriseDetail(locale));
  };

  const handleResend = () => {
    const body = {
      id: viewData?.id,
      detail: {},
    };
    dispatch(
      resendEnterpriseInviteCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="d-flex justify-between">
            <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
              <FormattedMessage id="Enterprise" />
            </h2>
          </div>
          {!loading && (
            <Row
              className="mt-3"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Col md={2} className="mt-4">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  Search:
                </div>
                <div>
                  <LabelWithInput
                    // label=""
                    placeholder="Search"
                    name="search"
                    type="text"
                    marginLabelTop={'0'}
                    marginTop={'0'}
                    bgColor="white"
                    placeholdercolor="#000000"
                    value={formData?.search}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </Col>
              <Col md={2} className="mt-5">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#375241] h-[44px] flex items-center justify-center text-white cursor-pointer"
                  onClick={() => {
                    handleApply();
                  }}
                >
                  Apply
                </div>
              </Col>
              <Col md={8} className="mt-5 justify-content-end d-flex">
                <div
                  className="w-full md:max-w-[30%] lg:max-w-[20%] fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#874529] h-[44px] flex items-center justify-center text-white cursor-pointer gap-[10px]"
                  onClick={() => {
                    setDrawerOpen(true);
                    setViewData({});
                  }}
                >
                  <Image src={AddIcon} alt={'icon'} />
                  <div>Create</div>
                </div>
              </Col>
            </Row>
          )}
          {enterpriseLoader || loading ? (
            <Loader />
          ) : (
            <div className="mt-[30px]">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Enterprise Name" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Admin Details" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Skin Analyser" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Skin Concern Identifier" />
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Hair Anayser" />
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Subscription" />
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Internal" />
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Actions" />
                  </p>
                </Col>
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {enterpriseList && enterpriseList?.length > 0 ? (
                  enterpriseList?.map((item, index) => (
                    <Row
                      className="m-0 p-0 flex items-center listAppointment"
                      key={index}
                    >
                      <Col
                        lg={2}
                        md={6}
                        sm={12}
                        style={{
                          borderLeft: !item?.is_onboarded
                            ? '4px solid #F59E0B'
                            : '4px solid #059F3E',
                          cursor: 'pointer',
                          minHeight: '45px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                        }}
                        onClick={() => {
                          handleEnterpriseDetail(item);
                        }}
                      >
                        <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                          {item?.name}
                        </div>
                        {(item?.access_control?.hair_analyser_basic ||
                          item?.access_control?.skin_analyser_basic ||
                          item?.access_control?.skin_concern_identifier) && (
                          <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                            {item?.access_control?.skin_analyser_basic && (
                              <Image src={SkinAnalyserImg} alt="icon" />
                            )}
                            {item?.access_control?.skin_concern_identifier && (
                              <Image src={SkinConcernImg} alt="icon" />
                            )}
                            {item?.access_control?.hair_analyser_basic && (
                              <Image src={HairAnalyserImg} alt="icon" />
                            )}
                          </div>
                        )}
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all">
                          {item?.admin_details?.full_name}
                        </div>
                        <div className="pt-04 flex items-center gap-[10px]">
                          {item?.admin_details?.email && (
                            <Tooltip title={item?.admin_details?.email} arrow>
                              <Image
                                src={mail}
                                alt="icon"
                                style={{ cursor: 'pointer' }}
                              />
                            </Tooltip>
                          )}
                          {item?.admin_details?.contact_number && (
                            <Tooltip
                              title={
                                item?.admin_details?.country_code +
                                item?.admin_details?.contact_number
                              }
                              arrow
                            >
                              <Image
                                src={call}
                                alt="icon"
                                style={{ cursor: 'pointer' }}
                              />
                            </Tooltip>
                          )}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                          {`${item?.skin_analyser_count}/${item?.skin_analyser_limit}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                          {`${item?.skin_concern_identifier_count}/${item?.skin_concern_identifier_limit}`}
                        </div>
                      </Col>
                      <Col lg={1} md={6} sm={12}>
                        <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                          {`${item?.hair_analyser_count}/${item?.hair_analyser_limit}`}
                        </div>
                      </Col>
                      <Col lg={1} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {item?.subscription ? item?.subscription : 'NA'}
                        </div>
                      </Col>
                      <Col lg={1} md={6} sm={12}>
                        <SwitchList
                          checked={item?.is_internal}
                          onChange={() => {}}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </Col>
                      <Col lg={1} md={6} sm={12}>
                        <MoreVertOutlinedIcon
                          aria-describedby={id}
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => handleAction(e, item)}
                        />
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="flex flex-col justify-center items-center py-[50px]">
                    <Image
                      src={EmptyScreen}
                      alt="icon"
                      width={'301px'}
                      height={'224px'}
                    />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                      Nothing here yet
                    </div>
                  </div>
                )}
              </Row>
            </div>
          )}
          {!enterpriseLoader && !loading && (
            <div className="mt-[20px] flex items-center justify-end gap-[24px]">
              <div className="flex items-center gap-[8px]">
                <div className="h-[18px] w-[18px] bg-[#F59E0B]"></div>
                <div className="text-[14px] text-[#202224] lh-2 family_outfit_regular_400">
                  Invited
                </div>
              </div>
              <div className="flex items-center gap-[8px]">
                <div className="h-[18px] w-[18px] bg-[#059F3E]"></div>
                <div className="text-[14px] text-[#202224] lh-2 family_outfit_regular_400">
                  Onboarded
                </div>
              </div>
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
        </Col>
      </Row>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box>
          {!viewData?.is_onboarded && (
            <Box
              onClick={() => {
                handleResend();
                handleClose();
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 3,
                py: 1,
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <RefreshIcon fontSize="small" />
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 400,
                  fontFamily: 'Outfit, sans-serif',
                }}
              >
                Resend Invite
              </Typography>
            </Box>
          )}
          <Box
            onClick={() => {
              setDrawerOpen(true);
              handleClose();
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 3,
              py: 1,
              cursor: 'pointer',
              borderBottom: '1px solid #eee',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <EditIcon fontSize="small" />
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                fontFamily: 'Outfit, sans-serif',
              }}
            >
              Edit
            </Typography>
          </Box>
          <Box
            onClick={() => {
              setIsModalActive(true);
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 3,
              py: 1,
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <DeleteIcon fontSize="small" />
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                fontFamily: 'Outfit, sans-serif',
              }}
            >
              Delete
            </Typography>
          </Box>
        </Box>
      </Popover>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModalActive}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      setIsModalActive(false);
                      handleClose();
                    }}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      handleDelete();
                      handleClose();
                    }}
                    loading={enterpriseDeleteLoader}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />

      <CreateEnterprise
        open={drawerOpen}
        onClose={handleDrawerClose}
        countryData={countryData}
        enterpriseTypeData={enterpriseTypeData}
        productInventoryData={productInventoryData}
        editData={viewData}
      />
    </div>
  );
};

export default Enterprise;
